import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const VideoOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M12 3.96c4.43 0 8.04 3.61 8.04 8.04s-3.61 8.04-8.04 8.04S3.96 16.43 3.96 12 7.57 3.96 12 3.96Zm0-1.6c-5.32 0-9.64 4.32-9.64 9.64s4.32 9.64 9.64 9.64 9.64-4.32 9.64-9.64S17.32 2.36 12 2.36Z"
      fill={color}
    />
    <Path
      d="M15.74 11.34c.47.31.47 1 0 1.31l-2.7 1.8-2.46 1.64a.792.792 0 0 1-1.23-.66V8.54c0-.63.7-1.01 1.23-.66l2.46 1.64 2.7 1.8v.02Z"
      fill={color}
    />
  </Svg>
)

export default VideoOutlined
